<template>
  <div class="farm-running-status">
    <div
      v-if="title != null && title != ''"
      style="
        height: 50px;
        display: flex;
        align-items: center;
        color: white;
        background-color: rgb(91, 161, 230);
      "
    >
      <div :style="'width: ' + width / 6 + 'px'">
        <div
          style="width: 100%; height: 50px; display: flex; align-items: center"
          @click="fanhui()"
        >
          <img
            style="float: left; margin-left: 20px; width: 10px; height: 16px"
            src="../../public/img/fhimg.png"
          />
        </div>
      </div>
      <div style="width: 100%">{{ title }}</div>
      <div :style="'width: ' + width / 6 + 'px'"></div>
    </div>

    <div class="status-content">
      <div class="summary-bar">
        <div class="farm-info">
          <div class="farm-name">{{ statusData.farmName || "-" }}</div>
          <div class="stat-time">统计时间：{{ statusData.statTime || "-" }}</div>
        </div>
        <div class="summary-actions">
          <el-button
            v-if="!statusLoaded"
            size="small"
            type="primary"
            :loading="loading"
            @click="getStatusData"
          >
            刷新
          </el-button>
          <el-button
            v-if="showRefreshQueryButton"
            size="small"
            type="warning"
            :loading="refreshLoading"
            @click="refreshStatusData"
          >
            重新查询
          </el-button>
        </div>
      </div>

      <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>

      <div class="status-table-wrap" v-loading="loading">
        <table class="status-table">
          <colgroup>
            <col class="col-device" />
            <col class="col-number" />
            <col class="col-number" />
            <col class="col-rate" />
            <col class="col-number" />
            <col class="col-number" />
            <col class="col-number" />
            <col class="col-number" />
            <col class="col-number" />
            <col class="col-rate" />
          </colgroup>
          <thead>
            <tr>
              <th>设备类型</th>
              <th>总数</th>
              <th>离线数</th>
              <th>在线率</th>
              <th>信号差</th>
              <th>低电数</th>
              <th>终端多</th>
              <th>控制次数</th>
              <th>失败次数</th>
              <th>成功率</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in deviceRows" :key="item.key">
              <td>
                <div class="device-name">
                  <span>{{ item.name }}</span>
                </div>
                <div class="device-model">{{ item.model }}</div>
              </td>
              <td>
                <template v-if="item.key === 'dfvalve'">
                  <div>控制器: {{ item.total }}</div>
                  <div>执行器: {{ item.actuatorTotal }}</div>
                </template>
                <template v-else>{{ showTotal(item.total) }}</template>
              </td>
              <td :class="{ warn: item.offline > 0 }">
                  <span v-if="item.offline > 0" class="abnormal-icon-wrap">
                    {{ showAbnormal(item.offline) }}
                    <i class="abnormal-icon" @click.stop="openDetail(item, 'offline')">!</i>
                  </span>
                  <span v-else>{{ showAbnormal(item.offline) }}</span>
                </td>
              <td :class="rateClass(item.onlineRate)">
                {{ formatPercent(item.onlineRate) }}
              </td>
              <td :class="{ warn: item.lowSignal > 0 }">
                <span v-if="item.lowSignal > 0" class="abnormal-icon-wrap">
                  {{ showAbnormal(item.lowSignal) }}
                  <i class="abnormal-icon" @click.stop="openDetail(item, 'lowSignal')">!</i>
                </span>
                <span v-else>{{ showAbnormal(item.lowSignal) }}</span>
              </td>
              <td :class="{ warn: item.lowVoltage > 0 }">
                <span v-if="item.lowVoltage > 0" class="abnormal-icon-wrap">
                  {{ showAbnormal(item.lowVoltage) }}
                  <i class="abnormal-icon" @click.stop="openDetail(item, 'lowVoltage')">!</i>
                </span>
                <span v-else>{{ showAbnormal(item.lowVoltage) }}</span>
              </td>
              <td :class="{ warn: item.terminalOverLimit > 0 }">
                <span v-if="item.terminalOverLimit > 0" class="abnormal-icon-wrap">
                  {{ showAbnormal(item.terminalOverLimit) }}
                  <i class="abnormal-icon" @click.stop="openDetail(item, 'terminalOverLimit')">!</i>
                </span>
                <span v-else>{{ showAbnormal(item.terminalOverLimit) }}</span>
              </td>
              <td>{{ showAbnormal(item.control) }}</td>
              <td :class="{ warn: item.failCount > 0 }">
                <span v-if="item.failCount > 0" class="abnormal-icon-wrap">
                  {{ showAbnormal(item.failCount) }}
                  <i class="abnormal-icon" @click.stop="openDetail(item, 'failCount')">!</i>
                </span>
                <span v-else>{{ showAbnormal(item.failCount) }}</span>
              </td>
              <td :class="rateClass(item.successRate)">
                <span v-if="item.control > 0">{{ formatPercent(item.successRate) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mobile-status-list" v-loading="loading">
        <div
          v-for="item in deviceRows"
          :key="item.key"
          class="mobile-status-card"
        >
          <div class="mobile-card-header">
            <div>
              <div class="device-name">
                <span>{{ item.name }}</span>
              </div>
              <div class="device-model">{{ item.model }}</div>
            </div>
            <div class="mobile-rate">
              <div v-if="['valve', 'valve4g', 'dfvalve'].includes(item.key) && item.control > 0" class="mobile-rate-success">
                <div class="mobile-rate-label">成功率</div>
                <div :class="rateClass(item.successRate)">
                  {{ formatPercent(item.successRate) }}
                </div>
              </div>
              <div class="mobile-rate-online">
                <div class="mobile-rate-label">在线率</div>
                <div :class="rateClass(item.onlineRate)">
                  {{ formatPercent(item.onlineRate) }}
                </div>
              </div>
            </div>
          </div>

          <div class="mobile-metrics">
            <div
              v-for="metric in getVisibleMetrics(item)"
              :key="metric.label"
              class="mobile-metric"
            >
              <div class="metric-label">{{ metric.label }}</div>
              <div class="metric-value" :class="metric.className">
                <span v-if="metric.abnormalType">
                  {{ metric.value }}
                  <i class="abnormal-icon" @click.stop="openDetail(item, metric.abnormalType)">!</i>
                </span>
                <span v-else>{{ metric.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      :width="width <= 600 ? '92%' : '980px'"
      append-to-body
      class="detail-dialog"
    >
      <div>
        <div v-if="detailErrorMsg" class="error-msg">{{ detailErrorMsg }}</div>

        <div v-if="detailLoading" class="detail-loading">
          <div class="detail-loading-spinner"></div>
          <div class="detail-loading-text">正在加载异常详情</div>
        </div>

        <div v-if="detailList.length > 0 && !detailLoading" class="detail-search">
          <el-input
            v-model.trim="detailSearchKeyword"
            size="small"
            clearable
            prefix-icon="el-icon-search"
            placeholder="请输入设备号搜索"
          ></el-input>
        </div>

        <div v-if="detailList.length === 0 && !detailLoading" class="empty-detail">
          暂无异常详情
        </div>

        <div
          v-else-if="filteredDetailList.length === 0 && !detailLoading"
          class="empty-detail"
        >
          未找到匹配设备
        </div>

        <div v-if="filteredDetailList.length > 0 && !detailLoading" class="detail-table-wrap">
          <table class="detail-table">
            <thead>
              <tr>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">设备位置</th>
                <th>设备地址</th>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">设备类型</th>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">异常状态</th>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">电压</th>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">信号</th>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">信噪比</th>
                <th v-if="!isOtherErrorMode">终端数量/所属网关</th>
                <th v-if="!isTerminalOverLimitMode && !isOtherErrorMode">时间</th>
                <th v-if="isOtherErrorMode">异常原因</th>
                <th v-else-if="!isTerminalOverLimitMode">分析结果</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="detail in filteredDetailList" :key="detail.id">
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode">{{ getDevicePosition(detail) }}</td>
                <td :class="{ warn: isDeviceAbnormal(detail) }">
                  {{ showText(detail.deviceName) }}
                </td>
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode">{{ showText(detail.deviceType) }}</td>
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode">
                  <span
                    v-for="tag in getAbnormalList(detail)"
                    :key="tag"
                    class="abnormal-tag"
                  >
                    {{ tag }}
                  </span>
                </td>
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode" :class="{ warn: isLowVoltage(detail) }">
                  {{ showText(detail.voltage) }}
                </td>
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode" :class="{ warn: isLowSignal(detail) }">
                  {{ showText(detail.signal) }}
                </td>
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode" :class="{ warn: isSignalNoiseAbnormal(detail) }">
                  {{ showText(detail.snr || detail.signal2noiseRatioUp || detail.signal2noiseRatioDown) }}
                </td>
                <td v-if="!isOtherErrorMode">
                  <span :class="{ warn: detail.terminalOverLimit > 0 }">
                    {{ getTerminalText(detail) }}
                  </span>
                </td>
                <td v-if="!isTerminalOverLimitMode && !isOtherErrorMode" :class="{ warn: isOffline(detail) }">
                  {{ showText(detail.deviceTime) }}
                </td>
                <td v-if="isOtherErrorMode">
                  {{ showText(detail.otherErrorReason) }}
                </td>
                <td v-else-if="!isTerminalOverLimitMode">
                  <template v-if="hasAnalysisResult(detail) || showAnalyzeButton(detail)">
                    <button
                      v-if="showAnalyzeButton(detail)"
                      class="analyze-btn"
                      type="button"
                      :disabled="isAnalyzingDetail(detail)"
                      @click="analyzeDetail(detail)"
                    >
                      <i
                        :class="
                          isAnalyzingDetail(detail)
                            ? 'el-icon-loading'
                            : 'el-icon-refresh'
                        "
                      ></i>
                    </button>
                    <span
                      v-else
                      :class="{ 'analysis-result': hasAnalysisResult(detail) }"
                    >
                      {{ getAnalysisText(detail) }}
                    </span>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="filteredDetailList.length > 0 && !detailLoading" class="mobile-detail-list">
          <div
            v-for="detail in filteredDetailList"
            :key="detail.id"
            class="mobile-detail-card"
          >
            <div class="mobile-detail-title" :class="{ 'no-border': isTerminalOverLimitMode }">
              <div class="mobile-detail-head">
                <div class="mobile-detail-main">
                  <span
                    class="mobile-detail-name"
                    :class="{ warn: isDeviceAbnormal(detail) }"
                  >
                    {{ showText(detail.deviceName) }}
                  </span>
                  <span v-if="isOtherErrorMode" class="mobile-detail-tags">
                    <span class="abnormal-tag">其他异常</span>
                  </span>
                  <span v-else-if="!isTerminalOverLimitMode" class="mobile-detail-tags">
                    <span
                      v-for="tag in getAbnormalList(detail)"
                      :key="tag"
                      class="abnormal-tag"
                    >
                      {{ tag }}
                    </span>
                  </span>
                  <div v-else class="mobile-detail-tags">
                    <span class="abnormal-tag">终端超限</span>
                  </div>
                </div>
                <div class="mobile-detail-position">
                  <span class="position-text">{{ getDevicePosition(detail) }}</span>
                  <span v-if="isSfjMode && detail.deviceTime" class="sfj-time">
                    {{ showText(detail.deviceTime) }}
                  </span>
                  <span v-else-if="isTerminalOverLimitMode" class="terminal-count-text">
                    终端数量:{{ getTerminalText(detail) }}
                  </span>
                  <span v-else-if="isGatewayMode && detail.deviceTime" class="sfj-time">
                    {{ showText(detail.deviceTime) }}
                  </span>
                  <span v-else-if="isGatewayMode" class="terminal-count-text">
                    终端数量:{{ getTerminalText(detail) }}
                  </span>
                  <span v-else-if="isMoistureMode && detail.deviceTime" class="sfj-time">
                    {{ showText(detail.deviceTime) }}
                  </span>
                  <span v-else-if="isDfValveMode && detail.deviceTime" class="sfj-time">
                    {{ showText(detail.deviceTime) }}
                  </span>
                  <span v-else-if="isOtherErrorMode && !isGatewayMode && detail.deviceTime" class="sfj-time">
                    {{ showText(detail.deviceTime) }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="isOtherErrorMode" class="mobile-detail-grid">
              <div class="detail-field detail-field-full">
                <span>异常原因</span>
                <strong :class="{ 'analysis-result': detail.otherErrorReason }">
                  {{ showText(detail.otherErrorReason) }}
                </strong>
              </div>
            </div>
            <div v-else-if="(isLoraControlFailMode || (isValve4gMode && currentAbnormalType === 'failCount') || (isDfValveMode && currentAbnormalType === 'failCount')) && detail.isControl === 1" class="mobile-detail-grid">
              <div class="detail-field">
                <span>控制类型</span>
                <strong>{{ showText(detail.controlType) }}</strong>
              </div>
              <div class="detail-field">
                <span>控制内容</span>
                <strong>{{ showText(detail.controlContent) }}</strong>
              </div>
              <div class="detail-field">
                <span>当前状态</span>
                <strong>{{ showText(detail.nowStatus) }}</strong>
              </div>
              <div class="detail-field">
                <span>控制结果</span>
                <strong>{{ showText(detail.controlResult) }}</strong>
              </div>
              <div class="detail-field">
                <span>控制时间</span>
                <strong>{{ showText(detail.controlTime) }}</strong>
              </div>
              <div class="detail-field">
                <span>响应时间</span>
                <strong>{{ showText(detail.responseTime) }}</strong>
              </div>
              <div v-if="!(isDfValveMode && currentAbnormalType === 'failCount') && (hasAnalysisResult(detail) || showAnalyzeButton(detail))" class="detail-field detail-field-full">
                <span>分析结果</span>
                <template v-if="isValve4gMode && currentAbnormalType === 'failCount'">
                  <strong :class="{ 'analysis-result': detail.controlErrorReason }">
                    {{ showText(detail.controlErrorReason) }}
                  </strong>
                </template>
                <template v-else-if="!isLoraLowSignalMode && !isValve4gLowSignalMode">
                  <button
                    v-if="showAnalyzeButton(detail)"
                    class="analyze-btn analyze-btn-mobile"
                    type="button"
                    :disabled="isAnalyzingDetail(detail)"
                    @click="analyzeDetail(detail)"
                  >
                    <i
                      :class="
                        isAnalyzingDetail(detail)
                          ? 'el-icon-loading'
                          : 'el-icon-refresh'
                      "
                    ></i>
                  </button>
                  <strong
                    v-else
                    :class="{ 'analysis-result': hasAnalysisResult(detail) }"
                  >
                    {{ getAnalysisText(detail) }}
                  </strong>
                </template>
              </div>
            </div>
            <div v-else-if="!isTerminalOverLimitMode" class="mobile-detail-grid">
              <template v-if="!isGatewayMode">
                <div v-if="!isSfjMode && !isMoistureMode && !isDfValveMode" class="detail-field">
                  <span>类型</span>
                  <strong>{{ showText(detail.deviceType) }}</strong>
                </div>
                <div class="detail-field">
                  <span>电压</span>
                  <strong :class="{ warn: isLowVoltage(detail) }">
                    {{ showText(detail.voltage) }}
                  </strong>
                </div>
                <div class="detail-field">
                  <span>信号</span>
                  <strong :class="{ warn: isLowSignal(detail) }">
                    {{ showText(detail.signal) }}
                  </strong>
                </div>
                <div v-if="!isSfjMode && !isValve4gMode && !isMoistureMode && !isDfValveMode && !isWeatherMode && !isPumpMode" class="detail-field">
                  <span>信噪比</span>
                  <strong :class="{ warn: isSignalNoiseAbnormal(detail) }">
                    {{ showText(detail.snr || detail.signal2noiseRatioUp || detail.signal2noiseRatioDown) }}
                  </strong>
                </div>
                <div v-if="!isSfjMode && !isValve4gMode && !isMoistureMode && !isDfValveMode && !isWeatherMode && !isPumpMode" class="detail-field">
                  <span>所属网关</span>
                  <strong :class="{ warn: detail.terminalOverLimit > 0 }">
                    {{ showText(detail.gatewayNo) }}
                  </strong>
                </div>
                <div v-if="!isSfjMode && !isMoistureMode && !isDfValveMode" class="detail-field">
                  <span>时间</span>
                  <strong :class="{ warn: isOffline(detail) }">
                    {{ showText(detail.deviceTime) }}
                  </strong>
                </div>
              </template>
              <template v-if="isGatewayMode">
                <div class="detail-field">
                  <span>类型</span>
                  <strong>{{ showText(detail.deviceType) }}</strong>
                </div>
                <div class="detail-field">
                  <span>电压</span>
                  <strong :class="{ warn: isLowVoltage(detail) }">
                    {{ showText(detail.voltage) }}
                  </strong>
                </div>
                <div class="detail-field">
                  <span>信号</span>
                  <strong :class="{ warn: isLowSignal(detail) }">
                    {{ showText(detail.signal) }}
                  </strong>
                </div>
                <div class="detail-field">
                  <span>终端数量</span>
                  <strong :class="{ warn: detail.terminalOverLimit > 0 }">
                    {{ getTerminalText(detail) }}
                  </strong>
                </div>
              </template>
              <div v-if="showAnalysisResult && (isValve4gLowVoltageMode || isLoraLowVoltageMode ? !!detail.lowVoltageReason : (hasAnalysisResult(detail) || showAnalyzeButton(detail) || showAnalyzeButtonForDevice))" class="detail-field detail-field-full">
                <span>分析结果</span>
                <template v-if="isValve4gLowVoltageMode || isLoraLowVoltageMode">
                  <strong :class="{ 'analysis-result': detail.lowVoltageReason }">
                    {{ showText(detail.lowVoltageReason) }}
                  </strong>
                </template>
                <template v-else>
                  <template v-if="hasAnalysisResult(detail)">
                    <strong :class="{ 'analysis-result': true }">
                      {{ getAnalysisText(detail) }}
                    </strong>
                  </template>
                  <button
                    v-else-if="showAnalyzeButton(detail) || showAnalyzeButtonForDevice"
                    class="analyze-btn analyze-btn-mobile"
                    type="button"
                    :disabled="isAnalyzingDetail(detail)"
                    @click="analyzeDetail(detail)"
                  >
                    <i
                      :class="
                        isAnalyzingDetail(detail)
                          ? 'el-icon-loading'
                          : 'el-icon-refresh'
                      "
                    ></i>
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  analyze4GOfflineReason,
  getFarmMonitorDeviceDetail,
  getFarmMonitorStatus,
  refreshFarmMonitorStatus,
} from "../utils/getxx";

export default {
  data() {
    return {
      width: window.innerWidth,
      title: null,
      loading: false,
      refreshLoading: false,
      statusLoaded: false,
      errorMsg: "",
      statusData: {},
      detailVisible: false,
      detailLoading: false,
      detailErrorMsg: "",
      detailList: [],
      detailSearchKeyword: "",
      currentDetailDevice: null,
      currentAbnormalType: null,
      analyzingMap: {},
    };
  },
  created() {
    this.title = this.$route.query.title;
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.getStatusData();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    farmId() {
      return this.$route.query.farmId || 34756;
    },
    monitorId() {
      return this.$route.query.monitorId || this.statusData.id;
    },
    isTerminalOverLimitMode() {
      return this.currentAbnormalType === "terminalOverLimit";
    },
    isSfjMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "sfj";
    },
    isLoraControlFailMode() {
      return this.currentDetailDevice && 
             this.currentDetailDevice.key === "valve" && 
             this.currentAbnormalType === "failCount";
    },
    isValve4gMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "valve4g";
    },
    isLoraLowSignalMode() {
      return this.currentDetailDevice && 
             this.currentDetailDevice.key === "valve" && 
             this.currentAbnormalType === "lowSignal";
    },
    isLoraLowVoltageMode() {
      return this.currentDetailDevice && 
             this.currentDetailDevice.key === "valve" && 
             this.currentAbnormalType === "lowVoltage";
    },
    isValve4gLowSignalMode() {
      return this.currentDetailDevice && 
             this.currentDetailDevice.key === "valve4g" && 
             this.currentAbnormalType === "lowSignal";
    },
    isValve4gLowVoltageMode() {
      return this.currentDetailDevice && 
             this.currentDetailDevice.key === "valve4g" && 
             this.currentAbnormalType === "lowVoltage";
    },
    isGatewayMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "gateway";
    },
    isMoistureMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "soil";
    },
    isDfValveMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "dfvalve";
    },
    isWeatherMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "weather";
    },
    isPumpMode() {
      return this.currentDetailDevice && this.currentDetailDevice.key === "pump";
    },
    isOtherErrorMode() {
      return this.currentAbnormalType === "otherError";
    },
    showAnalysisResult() {
      if (this.isLoraLowSignalMode || this.isValve4gLowSignalMode) {
        return false;
      }
      const lowVoltageOrSignal = this.currentAbnormalType === "lowVoltage" || this.currentAbnormalType === "lowSignal";
      if ((this.isDfValveMode || this.isWeatherMode || this.isMoistureMode || this.isPumpMode) && lowVoltageOrSignal) {
        return false;
      }
      if (this.isGatewayMode && this.currentAbnormalType === "lowVoltage") {
        return false;
      }
      return true;
    },
    showAnalyzeButtonForDevice() {
      return this.isGatewayMode || (this.isDfValveMode && this.currentAbnormalType === "offline");
    },
    filteredDetailList() {
      const keyword = String(this.detailSearchKeyword || "").trim();
      if (!keyword) {
        return this.detailList;
      }
      return this.detailList.filter((detail) =>
        String(detail.deviceName || "").includes(keyword)
      );
    },
    detailTitle() {
      const name = this.currentDetailDevice ? this.currentDetailDevice.name : "";
      const type = this.currentAbnormalType;
      let abnormalTypeText = "";
      switch (type) {
        case "offline":
          abnormalTypeText = "离线异常";
          break;
        case "lowSignal":
          abnormalTypeText = "信号差异常";
          break;
        case "lowVoltage":
          abnormalTypeText = "低电异常";
          break;
        case "terminalOverLimit":
          abnormalTypeText = "终端超限异常";
          break;
        case "otherError":
          abnormalTypeText = "其他异常";
          break;
        case "failCount":
          abnormalTypeText = "控制失败异常";
          break;
      }
      if (name && abnormalTypeText) {
        return `${name}${abnormalTypeText}`;
      }
      if (name) {
        return `${name}异常详情`;
      }
      return "异常详情";
    },
    showRefreshQueryButton() {
      if (!this.statusLoaded) {
        return false;
      }
      if (!this.statusData.statTime) {
        return true;
      }
      const time = new Date(
        String(this.statusData.statTime).replace(/-/g, "/")
      ).getTime();
      if (!Number.isFinite(time)) {
        return true;
      }
      return Date.now() - time > 60 * 60 * 1000;
    },
    deviceRows() {
      const data = this.statusData || {};
      const dfvalveRow = this.createRow("dfvalve", "蝶阀", "U682", data, "u68x");
      dfvalveRow.actuatorTotal = this.toNumber(data.dfvalveTotal);
      return [
        this.createRow("gateway", "网关", "B310L", data),
        dfvalveRow,
        this.createRow("valve4g", "4G球阀", "U510_4G", data),
        this.createRow("valve", "LORA终端", "U510", data),
        this.createRow("sfj", "施肥机", "1000", data),
        this.createRow("weather", "气象", "B310L", data),
        this.createRow("soil", "墒情", "F100", data),
        this.createRow("pump", "泵房", "U650", data),
      ].filter((item) => item.total > 0 || (item.key === "dfvalve" && item.actuatorTotal > 0));
    },
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    },
    async getStatusData() {
      this.loading = true;
      this.errorMsg = "";
      try {
        const res = await getFarmMonitorStatus({ farmId: this.farmId });
        this.statusData = res && res.data ? res.data : res || {};
        this.statusLoaded = true;
      } catch (err) {
        this.errorMsg = "设备状态获取失败，请稍后重试";
        // eslint-disable-next-line no-console
        console.error("获取农场设备状态失败：", err);
      } finally {
        this.loading = false;
      }
    },
    async refreshStatusData() {
      this.refreshLoading = true;
      this.errorMsg = "";
      try {
        const res = await refreshFarmMonitorStatus({ farmId: this.farmId });
        this.statusData = res && res.data ? res.data : res || {};
        this.statusLoaded = true;
      } catch (err) {
        this.errorMsg = "重新查询失败，请稍后重试";
        // eslint-disable-next-line no-console
        console.error("重新查询农场设备状态失败：", err);
      } finally {
        this.refreshLoading = false;
      }
    },
    createRow(key, name, model, data, fieldPrefix = key, totalOnly = false) {
      const total = this.toNumber(data[`${fieldPrefix}Total`]);
      const offline = this.toNumber(data[`${fieldPrefix}Offline`]);
      const control = this.toNumber(data[`${fieldPrefix}Control`]);
      const failCount = this.toNumber(data[`${fieldPrefix}FailCount`]);

      return {
        key,
        name,
        model,
        total,
        offline: totalOnly ? null : offline,
        lowSignal: totalOnly ? null : this.toNumber(data[`${fieldPrefix}LowSignal`]),
        lowVoltage: totalOnly ? null : this.toNumber(data[`${fieldPrefix}LowVoltage`]),
        terminalOverLimit:
          key === "gateway" ? this.toNumber(data.gatewayTerminalOverLimit) : null,
        otherError: totalOnly ? null : this.toNumber(data[`${fieldPrefix}OtherError`]),
        control: totalOnly ? null : control,
        failCount: totalOnly ? null : failCount,
        onlineRate: totalOnly ? null : (total > 0 ? ((total - offline) / total) * 100 : null),
        successRate: totalOnly ? null : (control > 0 ? ((control - failCount) / control) * 100 : null),
        totalOnly,
      };
    },
    hasAbnormal(item) {
      return [
        item.offline,
        item.lowSignal,
        item.lowVoltage,
        item.terminalOverLimit,
        item.failCount,
      ].some((value) => value > 0);
    },
    async openDetail(item, abnormalType = null) {
      this.currentDetailDevice = item;
      this.currentAbnormalType = abnormalType;
      this.detailVisible = true;
      this.detailLoading = true;
      this.detailErrorMsg = "";
      this.detailList = [];
      this.detailSearchKeyword = "";
      try {
        const res = await getFarmMonitorDeviceDetail({
          farmId: this.farmId,
          deviceType: item.model,
          monitorId: this.monitorId,
        });
        const data = res && res.data ? res.data : res;
        let list = Array.isArray(data) ? data : [];
        
        if (abnormalType) {
          list = this.filterByAbnormalType(list, abnormalType);
        }
        
        this.detailList = list;
      } catch (err) {
        this.detailErrorMsg = "异常详情获取失败，请稍后重试";
        // eslint-disable-next-line no-console
        console.error("获取农场异常设备详情失败：", err);
      } finally {
        this.detailLoading = false;
      }
    },
    filterByAbnormalType(list, abnormalType) {
      switch (abnormalType) {
        case "offline":
          return list.filter((item) => item.offline > 0);
        case "lowSignal":
          return list.filter((item) => item.lowSignal > 0);
        case "lowVoltage":
          return list.filter((item) => item.lowVoltage > 0);
        case "terminalOverLimit":
          return list.filter((item) => item.terminalOverLimit > 0);
        case "otherError":
          return list.filter((item) => item.otherError === 1 || item.otherError === "1");
        case "failCount":
          return list.filter((item) => item.isControl === 1 || item.isControl === "1");
        default:
          return list;
      }
    },
    async analyzeDetail(detail) {
      if (this.isAnalyzingDetail(detail)) {
        return;
      }
      this.$set(this.analyzingMap, detail.id, true);
      try {
        const res = await analyze4GOfflineReason({
          detailId: detail.id,
          deviceName: detail.deviceName,
        });
        const result = res && res.data ? res.data : res;
        const analysisText =
          typeof result === "string" ? result : result && result.data;
        this.$set(detail, "analysisResult", analysisText || "分析完成");
      } catch (err) {
        if (this.$message) {
          this.$message.error("分析结果获取失败，请稍后重试");
        }
        // eslint-disable-next-line no-console
        console.error("获取分析结果失败：", err);
      } finally {
        this.$set(this.analyzingMap, detail.id, false);
      }
    },
    toNumber(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    },
    showTotal(value) {
      return value == null ? "-" : value;
    },
    showAbnormal(value) {
      if (value == null || value === 0) {
        return "-";
      }
      return value;
    },
    getVisibleMetrics(item) {
      const metrics = [
        ...(item.key === "dfvalve"
          ? [
              {
                label: "控制器总数",
                value: this.showTotal(item.total),
                className: "",
                abnormalType: null,
              },
              {
                label: "执行器总数",
                value: this.showTotal(item.actuatorTotal),
                className: "",
                abnormalType: null,
              },
            ]
          : [
              {
                label: "总数",
                value: this.showTotal(item.total),
                className: "",
                abnormalType: null,
              },
            ]),
        {
          label: "离线数",
          value: this.showAbnormal(item.offline),
          className: item.offline > 0 ? "warn" : "",
          abnormalType: item.offline > 0 ? "offline" : null,
        },
        {
          label: "信号差",
          value: this.showAbnormal(item.lowSignal),
          className: item.lowSignal > 0 ? "warn" : "",
          abnormalType: item.lowSignal > 0 ? "lowSignal" : null,
        },
        {
          label: "低电数",
          value: this.showAbnormal(item.lowVoltage),
          className: item.lowVoltage > 0 ? "warn" : "",
          abnormalType: item.lowVoltage > 0 ? "lowVoltage" : null,
        },
        {
          label: "终端超限",
          value: this.showAbnormal(item.terminalOverLimit),
          className: item.terminalOverLimit > 0 ? "warn" : "",
          abnormalType: item.terminalOverLimit > 0 ? "terminalOverLimit" : null,
        },
        {
          label: "其他异常",
          value: this.showAbnormal(item.otherError),
          className: item.otherError > 0 ? "warn" : "",
          abnormalType: (item.otherError > 0 && ["gateway", "valve"].includes(item.key)) ? "otherError" : null,
        },
        {
          label: "控制次数",
          value: this.showAbnormal(item.control),
          className: "",
          abnormalType: null,
        },
        {
          label: "失败次数",
          value: this.showAbnormal(item.failCount),
          className: item.failCount > 0 ? "warn" : "",
          abnormalType: item.failCount > 0 ? "failCount" : null,
        },
      ];
      return metrics.filter((metric) => metric.value !== "-");
    },
    showText(value) {
      if (value == null || value === "") {
        return "-";
      }
      return value;
    },
    getDevicePosition(detail) {
      const position = [detail.landName, detail.pileName, detail.stakeName]
        .filter((item) => item != null && item !== "")
        .join(" / ");
      return position || detail.farmName || "-";
    },
    getAbnormalList(detail) {
      const list = [];
      if (detail.offline > 0) {
        list.push("离线");
      }
      if (detail.lowSignal > 0) {
        list.push("信号差");
      }
      if (detail.lowVoltage > 0) {
        list.push("低电");
      }
      if (detail.terminalOverLimit > 0 && !(this.isOtherErrorMode && this.isGatewayMode)) {
        list.push("终端超限");
      }
      if (detail.isControl === 1 || detail.isControl === "1") {
        list.push("控制失败");
      }
      return list;
    },
    getAbnormalText(detail) {
      return this.getAbnormalList(detail).join("、");
    },
    getTerminalText(detail) {
      if (detail.terminalCount != null && detail.terminalCount !== "") {
        return detail.terminalCount;
      }
      return this.showText(detail.gatewayNo);
    },
    getAnalysisText(detail) {
      return (
        detail.analysisResult ||
        detail.offlineReason ||
        detail.lowVoltageReason ||
        detail.controlErrorReason ||
        "-"
      );
    },
    hasAnalysisResult(detail) {
      return this.getAnalysisText(detail) !== "-";
    },
    showAnalyzeButton(detail) {
      return this.canAnalyzeDevice(detail) && !this.hasAnalysisResult(detail);
    },
    canAnalyzeDevice(detail) {
      return ["1000", "U510_4G", "U650", "F100"].includes(
        String(detail.deviceType)
      );
    },
    isAnalyzingDetail(detail) {
      return !!this.analyzingMap[detail.id];
    },
    isOffline(detail) {
      return detail.offline > 0;
    },
    isLowSignal(detail) {
      return detail.lowSignal > 0;
    },
    isLowVoltage(detail) {
      return detail.lowVoltage > 0;
    },
    isTerminalOverLimit(detail) {
      return detail.terminalOverLimit > 0;
    },
    isControlFail(detail) {
      return detail.controlResult === 0 || detail.controlResult === "0";
    },
    isSignalNoiseAbnormal(detail) {
      return this.isLowSignal(detail) && this.showText(
        detail.snr || detail.signal2noiseRatioUp || detail.signal2noiseRatioDown
      ) !== "-";
    },
    isDeviceAbnormal(detail) {
      return [
        this.isOffline(detail),
        this.isLowSignal(detail),
        this.isLowVoltage(detail),
        this.isTerminalOverLimit(detail),
        this.isControlFail(detail),
        detail.otherError === 1 || detail.otherError === "1",
      ].some(Boolean);
    },
    formatPercent(value) {
      if (value == null || Number.isNaN(value)) {
        return "-";
      }
      return `${value.toFixed(2)}%`;
    },
    rateClass(value) {
      if (value == null || Number.isNaN(value)) {
        return "";
      }
      if (value >= 95) {
        return "rate-good";
      }
      if (value >= 80) {
        return "rate-normal";
      }
      return "rate-bad";
    },
    fanhui() {
      if (window.AndroidBridge) {
        AndroidBridge.fanhui();
      }
    },
  },
};
</script>

<style scoped>
.farm-running-status {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  background: #f4f7fb;
  text-align: left;
  box-sizing: border-box;
}

.status-content {
  padding: 12px;
}

.summary-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.farm-info {
  min-width: 0;
}

.summary-actions {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
}

.summary-actions /deep/ .el-button + .el-button {
  margin-left: 0;
}

.farm-name {
  color: #1f2d3d;
  font-size: 18px;
  font-weight: 600;
}

.stat-time {
  margin-top: 4px;
  color: #8795a6;
  font-size: 13px;
}

.error-msg {
  margin-bottom: 10px;
  padding: 9px 12px;
  color: #c45656;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  font-size: 13px;
}

.status-table-wrap {
  overflow-x: hidden;
  background: #ffffff;
  border: 1px solid #e1e6ed;
  border-radius: 6px;
}

.status-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  color: #34495e;
  font-size: 14px;
}

.col-device {
  width: 20%;
}

.col-number {
  width: 8.5%;
}

.col-rate {
  width: 12%;
}

.status-table th,
.status-table td {
  height: 44px;
  padding: 8px 10px;
  border-right: 1px solid #e1e6ed;
  border-bottom: 1px solid #e1e6ed;
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.status-table th {
  color: #6b7785;
  background: #fbfcfe;
  font-weight: 600;
}

.status-table tr:last-child td {
  border-bottom: 0;
}

.status-table th:last-child,
.status-table td:last-child {
  border-right: 0;
}

.device-name {
  color: #263445;
  font-weight: 600;
}

.abnormal-icon-wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.abnormal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  color: #ffffff;
  background: #d9534f;
  border: 0;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  font-style: normal;
}

.device-model {
  margin-top: 2px;
  color: #98a6b5;
  font-size: 12px;
}

.rate-good {
  color: #3b8f3f;
  font-weight: 600;
}

.rate-normal {
  color: #e6a23c;
  font-weight: 600;
}

.rate-bad,
.warn {
  color: #d9534f;
  font-weight: 700;
}

.analysis-result {
  color: #409eff;
  font-weight: 700;
}

.detail-table .analysis-result {
  color: #409eff;
  font-weight: 700;
}

.analyze-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 26px;
  padding: 0;
  color: #0b63ce;
  background: #eef6ff;
  border: 1px solid #b8dcff;
  border-radius: 6px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
}

.analyze-btn:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.mobile-status-list {
  display: none;
}

.detail-dialog /deep/ .el-dialog {
  overflow: hidden;
  border-radius: 8px;
}

.detail-dialog /deep/ .el-dialog__header {
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e6ebf2;
}

.detail-dialog /deep/ .el-dialog__title {
  color: #263445;
  font-size: 18px;
  font-weight: 600;
}

.detail-dialog /deep/ .el-dialog__body {
  padding: 16px;
  background: #f4f7fb;
}

.detail-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 180px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
}

.detail-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #d9ecff;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: detail-loading-rotate 0.9s linear infinite;
}

.detail-loading-text {
  margin-top: 12px;
  color: #8795a6;
  font-size: 14px;
}

.detail-search {
  margin-bottom: 10px;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
}

.detail-search /deep/ .el-input__inner {
  height: 36px;
  line-height: 36px;
  border-color: #dce5f0;
  border-radius: 6px;
}

@keyframes detail-loading-rotate {
  to {
    transform: rotate(360deg);
  }
}

.empty-detail {
  padding: 32px 0;
  color: #8795a6;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  text-align: center;
}

.detail-table-wrap {
  max-height: 58vh;
  overflow: auto;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  background: #ffffff;
}

.detail-table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  color: #34495e;
  font-size: 13px;
}

.detail-table th,
.detail-table td {
  min-height: 42px;
  padding: 11px 12px;
  border-right: 1px solid #e1e6ed;
  border-bottom: 1px solid #e1e6ed;
  line-height: 1.4;
  vertical-align: top;
}

.detail-table th {
  color: #52616f;
  background: #f8fafc;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}

.detail-table tbody tr:nth-child(even) {
  background: #fbfcfe;
}

.detail-table tbody tr:hover {
  background: #f3f7fc;
}

.detail-table tr:last-child td {
  border-bottom: 0;
}

.detail-table th:last-child,
.detail-table td:last-child {
  border-right: 0;
}

.mobile-detail-list {
  display: none;
}

.abnormal-tag {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  margin: 0 4px 4px 0;
  padding: 0 8px;
  color: #d9534f;
  background: #fff1f0;
  border: 1px solid #ffd7d4;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .status-content {
    padding: 10px;
  }

  .summary-bar {
    align-items: center;
    padding: 12px;
  }

  .summary-actions {
    gap: 6px;
  }

  .summary-actions /deep/ .el-button {
    padding: 8px 10px;
  }

  .farm-name {
    font-size: 16px;
  }

  .stat-time {
    font-size: 12px;
  }

  .status-table-wrap {
    display: none;
  }

  .mobile-status-list {
    display: block;
    padding-bottom: 16px;
  }

  .mobile-status-card {
    margin-bottom: 10px;
    padding: 12px;
    background: #ffffff;
    border: 1px solid #e1e6ed;
    border-radius: 6px;
  }

  .mobile-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #edf1f6;
  }

  .mobile-card-header .device-name {
    font-size: 16px;
  }

  .mobile-rate {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;
  }

  .mobile-rate-success,
  .mobile-rate-online {
    text-align: right;
  }

  .mobile-rate-label {
    margin-bottom: 2px;
    color: #8795a6;
    font-size: 12px;
    font-weight: 400;
  }

  .mobile-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 10px;
    row-gap: 8px;
    padding-top: 10px;
  }

  .mobile-metric {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
    padding: 8px 10px;
    background: #f7f9fc;
    border-radius: 4px;
  }

  .metric-label {
    color: #8795a6;
    font-size: 12px;
  }

  .metric-value {
    color: #263445;
    font-size: 15px;
    font-weight: 600;
  }

  .metric-value.rate-good,
  .metric-value.rate-normal,
  .metric-value.rate-bad,
  .metric-value.warn {
    font-weight: 600;
  }

  .metric-value.rate-good {
    color: #3b8f3f;
  }

  .metric-value.rate-normal {
    color: #e6a23c;
  }

  .metric-value.rate-bad,
  .metric-value.warn {
    color: #d9534f;
  }

  .detail-dialog /deep/ .el-dialog {
    margin-top: 6vh !important;
    border-radius: 8px;
  }

  .detail-dialog /deep/ .el-dialog__header {
    padding: 14px 16px;
  }

  .detail-dialog /deep/ .el-dialog__title {
    font-size: 17px;
  }

  .detail-dialog /deep/ .el-dialog__body {
    max-height: 76vh;
    overflow-y: auto;
    padding: 12px;
    -webkit-overflow-scrolling: touch;
  }

  .detail-loading {
    min-height: 150px;
  }

  .detail-search {
    margin-bottom: 10px;
    padding: 8px;
  }

  .detail-table-wrap {
    display: none;
  }

  .mobile-detail-list {
    display: block;
  }

  .mobile-detail-card {
    margin-bottom: 10px;
    padding: 12px;
    background: #ffffff;
    border: 1px solid #e1e6ed;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(38, 52, 69, 0.04);
  }

  .mobile-detail-title {
    padding: 0 0 12px;
    color: #263445;
    border-bottom: 1px solid #edf1f6;
    text-align: left;
  }

  .mobile-detail-title.no-border {
    padding-bottom: 0;
    border-bottom: none;
  }

  .mobile-detail-head {
    min-width: 0;
    text-align: left;
  }

  .mobile-detail-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-width: 0;
  }

  .mobile-detail-name {
    flex: 0 0 auto;
    color: #263445;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: 0;
    text-align: left;
    word-break: break-all;
  }

  .mobile-detail-name.warn {
    color: #d9534f;
    font-weight: 800;
  }

  .mobile-detail-position {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 7px;
    color: #8795a6;
    font-size: 13px;
    line-height: 1.35;
    text-align: left;
  }

  .mobile-detail-position .position-text {
    flex: 1;
    text-align: left;
  }

  .mobile-detail-position .sfj-time {
    flex: 0 0 auto;
    margin-left: 12px;
    color: #e74c3c;
    font-size: 12px;
    font-weight: 500;
    text-align: right;
    word-break: break-word;
  }

  .mobile-detail-position .terminal-count-text {
    flex: 0 0 auto;
    margin-left: 12px;
    color: #8795a6;
    font-size: 12px;
    font-weight: 500;
    text-align: right;
    word-break: break-word;
  }

  .mobile-detail-tags {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 6px;
    max-width: 52%;
    overflow-x: auto;
    text-align: right;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-detail-tags .abnormal-tag {
    margin: 0;
    min-height: 24px;
    padding: 0 9px;
    border-radius: 12px;
    font-size: 13px;
  }

  .mobile-detail-tags .terminal-count {
    display: block;
    margin-top: 4px;
    min-height: 24px;
    padding: 0 9px;
    color: #34495e;
    background: #f7f9fc;
    border: 1px solid #e1e6ed;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
  }

  .mobile-detail-tags .sfj-time {
    display: block;
    width: 100%;
    margin-top: 4px;
    color: #e74c3c;
    font-size: 12px;
    font-weight: 500;
    text-align: right;
  }

  .mobile-detail-tags::-webkit-scrollbar {
    display: none;
  }

  .mobile-detail-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding-top: 10px;
    color: #52616f;
    font-size: 12px;
    line-height: 1.45;
  }

  .detail-field {
    min-width: 0;
    padding: 8px;
    background: #f7f9fc;
    border-radius: 6px;
  }

  .detail-field span {
    display: block;
    color: #8795a6;
    font-size: 12px;
  }

  .detail-field strong {
    display: block;
    margin-top: 3px;
    color: #263445;
    font-size: 13px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .detail-field strong.warn {
    color: #d9534f;
    font-weight: 800;
  }

  .detail-field strong.analysis-result {
    color: #409eff;
    font-weight: 700;
  }

  .analyze-btn-mobile {
    display: flex;
    width: 38px;
    height: 30px;
    margin: 5px auto 0;
    font-size: 18px;
  }

  .detail-field-full {
    grid-column: 1 / -1;
  }
}
</style>
